import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import { registerComponent } from '../app'

const ImageZoom = (scope, el) => {
	const props = {
		loadingClass: 'loading',
		url: el.getAttribute('data-component-image-zoom')
	}

	const els = {
		img: el.querySelector('img'),
		pswp: document.querySelector('.pswp')
	}

	el.addEventListener('click', () => {
		el.classList.add(props.loadingClass)
		var img = new Image()

		img.onload = () => {
			el.classList.remove(props.loadingClass)
			const options = {
				index: 0,
				history: false,
				bgOpacity: 0.8,
				preloaderEl: true,
				getDoubleTapZoom: function(isMouseClick, item) {
					// isMouseClick          - true if mouse, false if double-tap
					// item                  - slide object that is zoomed, usually current
					// item.initialZoomLevel - initial scale ratio of image
					//                         e.g. if viewport is 700px and image is 1400px,
					//                              initialZoomLevel will be 0.5

					if (isMouseClick) {
						// is mouse click on image or zoom icon

						// zoom to original
						return 1

						// e.g. for 1400px image:
						// 0.5 - zooms to 700px
						// 2   - zooms to 2800px
					} else {
						// is double-tap

						// zoom to original if initial zoom is less than 0.7x,
						// otherwise to 1.5x, to make sure that double-tap gesture always zooms image
						return item.initialZoomLevel < 0.7 ? 1 : 1.2
					}
				}
			}
			const items = [
				{
					el: els.img,
					src: props.url,
					w: img.naturalWidth,
					h: img.naturalHeight,
					title: ''
				}
			]

			// init gallery
			const gallery = new PhotoSwipe(els.pswp, PhotoSwipeUI_Default, items, options)
			gallery.init()
		}

		img.src = props.url
	})
}

registerComponent('image-zoom', ImageZoom)
